import type { RowData } from '@tanstack/react-table';
import type { TableColumn, TableColumnDef } from '../tanstackTypes';
import type { ExtendedColumnDef } from '../types';

export type ResolvedColumnDef<
  TData extends RowData,
  TTexts = never,
> = TableColumnDef<TData> &
  Pick<
    ExtendedColumnDef<TData, TTexts>,
    'Aggregation' | 'Filter' | 'GroupHeader' | 'cellPadding'
  >;

export function getTableColumnDef<TData extends RowData>(
  column: TableColumn<TData>
): ResolvedColumnDef<TData> {
  return column.columnDef as ResolvedColumnDef<TData>;
}
